import React, {useContext} from "react";
import {useTranslation} from "react-i18next";

import {fetchGroupPage} from "../../../../state/api/groupAPI";
import DataList from "common/src/components/widget/DataList";
import {UserContext} from "../../../../context/UserContext";
import {hasRole} from "../../../../utils/userUtils";
import {Role} from "../../../../auth/roles";
const GroupList = () => {
    const {t} = useTranslation();
    const {user} = useContext(UserContext);

    return <DataList
        selector={(state) => state.groupAPI.page}
        loadingSelector={(state) => state.groupAPI.loading}

        fetchAction={fetchGroupPage}
        columns={[
            {name: t('group.name'), id: "name"},
            {name: t('group.description'), id: "description"},
            {name: t('group.number_of_users'), id: "numberOfUsersInGroup"}
        ]}
        filterColumns={[
            {id: "name", type: "string", name: t('group.name')},
            {id: "description", type: "string", name: t('group.description')},
            {id: "numberOfUsersInGroup", type: "number", name: t('group.number_of_users')},
        ]}
        defaultSort={"sort=name,asc"}
        showCreateButton={hasRole(user, Role.ADMIN_GROUPS)}
    />
}

export default GroupList;
